// src/App.jsx - 最终完整版
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import { mockPosts } from './api/mockData';
import PostCard from './components/PostCard';
import Header from './components/Header';
import ArchivePage from './pages/Archive';
import WritePost from './pages/WritePost';
import About from './pages/About';
import Auth from './pages/Auth';

// 首页组件
const Home = () => (
  <div style={{ maxWidth: 800, margin: '0 auto' }}>
    <h1 style={{ color: '#E1332D', textAlign: 'center', marginBottom: 24 }}>NBA文章列表</h1>
    {mockPosts.map(post => (
      <PostCard key={post.id} post={post} />
    ))}
  </div>
);

// 文章详情组件
const PostDetail = () => {
  const { id } = useParams();
  const post = mockPosts.find(item => item.id === Number(id));

  if (!post) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 24px' }}>
        <h3>文章不存在</h3>
        <p><a href="/">返回首页</a></p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '24px' }}>
      <h1 style={{ color: '#E1332D' }}>{post.title}</h1>
      <p style={{ fontSize: 16, lineHeight: 2 }}>{post.content}</p>
      <p><a href="/">返回首页</a></p>
    </div>
  );
};

// 404组件
const NotFound = () => (
  <div style={{ textAlign: 'center', padding: '100px 24px' }}>
    <h1 style={{ color: '#E1332D', fontSize: 48 }}>404</h1>
    <h3>页面不存在</h3>
    <p><a href="/">返回首页</a></p>
  </div>
);

// 根组件
function App() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Router>
        {/* 导航栏（在Router内，才能用Link） */}
        <Header />
        {/* 内容区 */}
        <main style={{ flex: 1, background: '#f5f5f5', padding: '24px' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/post/:id" element={<PostDetail />} />
            <Route path="/archive" element={<ArchivePage />} />
            <Route path="/writePost" element={<WritePost />} />
            <Route path="/about" element={<About />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        {/* 底部 */}
        <footer style={{ background: '#000', color: '#fff', padding: '16px', textAlign: 'center' }}>
          <p>NBA博客 ©2025 版权所有</p>
        </footer>
      </Router>
    </div>
  );
}

export default App;